export function firstRenderFeatures(target) {
    const hiddenClass = '--hidden';
    const mainContent = document.querySelectorAll('[data-main]');
    mainContent.forEach((content) => {
        content.classList.toggle(hiddenClass, content.dataset.main !== target);
    });
}
